<template>
  <div class="main-container">




    <!-- sec 1 (header) -->
    <div class="head-section">

      <!-- /action -->
      <div class="actions">
        <div>
          <i class="material-icons white--text" @click="$modal.hide('suggestions')">arrow_back_ios</i>
        </div>


        <div class="done" @click="fillTravelInfo()">
          Done
        </div>
      </div>
      <!-- /action -->


      <!-- head-->
      <div class="head">
        <div>{{headTag}}</div>
        <div>{{subheadTag}}</div>
      </div>
      <!-- /head-->
    </div>
    <!-- /sec 1 (header) -->


    <!-- sec 2 (input) -->
    <div class="input-section">
      <!-- input-header -->
      <div class="input-header">
        Your input
      </div>
      <!-- /input-header -->



      <!-- selected suggestions -->
      <div class="selected-suggestions">

        <!-- shows if arr is empty -->
        <div class="default-text text-xs-left">
          <textarea
            v-model="travel"
            placeholder="Tap here to start writing travel tips."/>
        </div>


      </div>
      <!-- /selected suggestions -->
    </div>
    <!-- /sec 2 (input) -->

    <!-- sec 3 (suggestions) -->
    <div class="suggestion-section white--text">
      <div class="suggestion-ques">
        Example questions to answer as travel tips.
        <br>
        What is this spot about?
        <br>
         Why should others visit this place?
        <br>
        Is it a crowded or touristic location?
        <br>
        What is the best daytime and season to visit? 
        <br>
        How can one get to the exact photo spot?
        <br>
        Is parking available? 
      </div>



    </div>
    <!-- /sec 3 (suggestions) -->

  </div>
</template>
<script>
  let vm
  export default {
    methods: {
      fillTravelInfo() {
        this.$store.state.uploadImage_3.travelInfo = this.travel
        this.travel = ''
        this.$modal.hide('suggestions')
      }
    },
    //
    data() {
      return {
        travel: ''
      }
    },
    //
    props: [
      'suggestionTag',
      'headTag',
      'subheadTag',
      'textVal'
    ],
    mounted() {
      setTimeout(()=> {
        let ele = document.getElementsByTagName('textarea')[0]
        ele.focus()
      }, 20)
    },
    async created() {
      vm = this
      this.travel = this.textVal
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/upload/suggestion";
</style>



// WEBPACK FOOTER //
// travel-info.vue?6ca027e2